import UtilsSet from "../../utils/set";
import {ViewType} from "../../const/views/view-type";
import {ALL_CUSTOM_VIEWS} from "../../const/views/view-type-config";

export default class PermissionsCustomView {

    constructor() {

    }

    static getValue(companyId:ID, userRole:any, viewId:ID) {
        return !gd.session.companies.get(companyId).settings.permissions.disabledCustomViews[userRole].has(viewId);
    }

    static setValue(companyId:ID, userRole:any, viewId:ID, value:any) {
        const { settings } = gd.session.companies.get(companyId);
        const disabledViews = settings.permissions.disabledCustomViews[userRole];

        if (!value) {
            disabledViews.add(viewId)
        } else {
            disabledViews.delete(viewId)
        }

        // settings.permissions.disabledCustomViews[userRole] = disabledViews
        settings.save();
    }

    static getAllAvailable():ViewType[] {

        // tut stranno vse... pohodu eto zapuskaetsya do togo kak company init...

        // tut ranshe peredavalas' company
        // const company = gd.company; - wow this generates error... why ?
        const company = gd.session.companies.get(gd.companyId);



        // some old views are multi company views (!) so no company really
        const companyRole = company ? gd.const.company.roleDictionary[company.role].toLowerCase() : null;

        const disabledViews = new Set(company.settings.permissions.disabledCustomViews[companyRole])

        if (gd.modules) {
            if (!gd.modules.meetings.enabled) {
                disabledViews.add(ViewType.MY_MEETINGS)
                disabledViews.add(ViewType.PROJECT_MEETINGS)
            }
            if (!gd.modules.chats.enabled) {
                disabledViews.add(ViewType.PROJECT_DISCUSSION)
            }
            if (!gd.modules.goals.enabled) {
                disabledViews.add(ViewType.MY_GOALS)
                disabledViews.add(ViewType.PROJECT_GOALS)
            }
            if (!gd.modules.clockInOut.enabled) {
                disabledViews.add(ViewType.MY_ATTENDANCE)
            }
        }


        switch (companyRole) {
            case 'manager':
            case 'user':
            case 'guest':
                return Array.from(
                    UtilsSet.difference(
                        new Set(ALL_CUSTOM_VIEWS),
                        disabledViews
                    )
                )
                // return company.settings.permissions.customViews[companyRole];
            default:
                return ALL_CUSTOM_VIEWS;
        }
    }

    static isAllowed(companyId:ID, viewId:ViewType) {
        return this.getAllAvailable().includes(viewId);
    }

}
